export default "__VITE_ASSET__0441e996__"